import { mapGetters } from "vuex";

export default {
  data: () => ({
    isDisabled:false,
    adv:{
      phone: null,
      name: null,
      email: null,
    },
  }),

  mounted () {

  },
  methods: {
    send(){
      this.$axios.post('support', {
        name: this.adv.name,
        email: this.adv.email,
        phone: this.adv.phone,
        text: 'Добрый день! Прошу предоставить консультирование по услуге страхование',
        title: 'Страхование',
        type: 'other',
        file: null,
      }).then(() => {
        this.adv = {
          phone: null,
          name: null,
          email: null,
        }
      })
    }
  },
  computed: {
    ...mapGetters([])
  },
}



// WEBPACK FOOTER //
// ./src/pages/Insurance/insurance.js